// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupContent-module-popupContent, .Popup-module-popup .PopupContent-module-popupContent {
  background-color: var(--popup-background);
  padding: 15px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

form .PopupContent-module-popupContent > section {
  display: flex;
  gap: 15px;
  flex-direction: column;
  width: 100%;
}

@media screen and (min-width: 380px) {

  .PopupContent-module-popupContent {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  :has(.PopupFooter-module-popupFooter) > .PopupContent-module-popupContent {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/Popup/components/PopupContent/PopupContent.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;AAEF","sourcesContent":[".popupContent, :global(.Popup-module-popup) .popupContent {\r\n  background-color: var(--popup-background);\r\n  padding: 15px;\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\nform .popupContent > section {\r\n  display: flex;\r\n  gap: 15px;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n@media screen and (min-width: 380px) {\r\n\r\n  .popupContent {\r\n    border-bottom-left-radius: 5px;\r\n    border-bottom-right-radius: 5px;\r\n  }\r\n\r\n  :has(:global(.PopupFooter-module-popupFooter)) > .popupContent {\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export var popupContent = `PopupContent-module-popupContent`;
export default ___CSS_LOADER_EXPORT___;
